import React from "react";
import { GetRoadHome } from "../components/newHome/GetRoadHome";
import learner from "../assets/images/learner-circle.png";
import Progressive from "../components/progressive/Progressive";
import { GuideTestimonials } from "../components/newpages/guide/GuideTestimonials";
const DrivingLessons = () => {
  return (
    <>
      <GetRoadHome
        heading="We'll Help Get Your Licence
"
        image={learner}
      />
      <Progressive/>
      <GuideTestimonials textWhite="text-white"/>
    </>
  );
};

export default DrivingLessons;
